<template>
  <div id="app">
    <live-qdd-model
      v-if="isLive"
      ref="live"
      @shareFg="openShareModel"
      @liveModel="liveModel"
      :loginUser="loginUser"
    ></live-qdd-model>
   
  
    <div class="notice" v-if="isNotice">
      <div class="notice-header" @click="seeVideo">
        <img class="notice-img" :src="liveInfo.cover_image" alt />
        <img class="notice-play" :src="imgPath + 'yijiu-sf-live-play.png'" alt />
      </div>
      <div class="notice-title">
        <div>{{liveInfo.title}}</div>
        <div class="notice-title-time">开播时间 {{liveInfo.live_time}} </div>
      </div>
      <div class="count-down">
        <div class="count-title">直播倒计时</div>
        <div class="count-model">
          <div>{{day}}</div>
          <p>天</p>
          <div>{{hour}}</div>
          <p>时</p>
          <div>{{min}}</div>
          <p>分</p>
          <div>{{second}}</div>
          <p>秒</p>
        </div>
      </div>
      <div class="notice-introduce">直播介绍</div>
      <div class="notice-p">{{liveInfo.describe}}</div>
      <div class="notice-btn" @click="openShareModel()">分享</div>
      <div class="goHome" @click="jumpHome('./homeIndex')">返回首页</div>
    </div>

    <van-share-sheet v-model="showShare" title="立即分享给好友" :options="options" @select="onSelect" />
    <!-- 分享提示 -->
    <van-overlay :show="show" class="share-tip" @click="show = false">
      <div class="wrapper" @click.stop>
        <img :src="imgPath + 'yj_share.png'" alt />
        <img @click="show = false" class="n_shareBtn" :src="imgPath + 'byj_utton.png'" alt />
      </div>
    </van-overlay>

    <div class="content_container">
      <vue-canvas-poster :widthPixels="1000" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
      <van-overlay :show="isPoster" @click="isPoster = false">
        <div class="wrapper" @click.stop>
          <div class="share-img">
            <img class="n_canvas" :src="posterImg" alt="分享图片" />
            <p class="n_save">长按保存到本地</p>
          </div>
        </div>
      </van-overlay>
    </div>

    <van-overlay :show="isShow" @click="clearIsShowFg">
      <div class="wrapper" @click.stop>
        <video width="90%" :src="videos" height="100%" controls autoplay class="n_margtop">
          <!-- <source :src="videos" type="video/ogg" />您的浏览器不支持Video标签。 -->
        </video>
      </div>
    </van-overlay>
    
  </div>
</template>

<script>
import { Dialog } from 'vant'
import liveQddModel from '../components/liveModel/live-qdd-model.vue'
import config from '../../config.js'
import share from '../public/share.js'
import wx from 'weixin-js-sdk'
import { format } from '../public/public'
export default {
  name: 'app',
  data() {
    return {
      options: [
        { name: '微信好友', icon: 'wechat' },
        { name: '朋友圈', icon: 'wechat-moments' },
        { name: '分享海报', icon: 'poster' },
      ],
      loginUser: {
        // union_id: '2 2',
        // nick_name: 'sf',
        // uid: '37041',
        // avatar:
        //   'https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTJoicIqXrbTSXeOfjbYicWpC9ibYlrCGSicb0buu2mVx7M4uquatcP58bwRwgu8yovesu8AYJU2eqs7Cg/132',
        // app_key: 'BD6479E3E3BDAA7A547E7C3800750172',
        // live_id: '38',
        // user_id: '37041',
        // open_id: 'owRqC4rTJP_IEOmgf2GgCW3KKrxM',
        // wechat_app_id: 'wxc0eee2bad939864a',
      },
      isLive: false,

      // 分享 预告
      isPreview: false,
      showShare: false,
      show: false,
      painting: {},
      isPoster: false,
      posterImg: '',
      isShow: false,
      videos: '',
      isNotice: false,
      live_id: '',

      liveInfo: {},

      leftTime: '',
      times: null,
      day: '',
      hour: '',
      min: '',
      second: '',
      isShare: false, // 分享进入
    }
  },
  watch: {
    '$store.state.shareStr': function (e) {
      if (e == 'live') {
        this.shareModelFg()
      }
    },
  },
  components: {
    liveQddModel,
  },
  created() {
    console.log('dddd++++++++++')
    if (!sessionStorage.getItem('isreload')) {
      location.reload()
      sessionStorage.setItem('isreload', 1)
    } else {
      if (this.$router.advance_id) {
        this.getIndexLiveData()

      } else {
        this.getIntoRoomStatus()
      }
    }
  },
  methods: {
    
    jumpHome(url) {
      this.$router.replace({ path: url })
    },
    // 分享
    shareModelFg() {
      let uid
      this.isShare = true
      if (localStorage.getItem('userInfo')) {
        uid = JSON.parse(localStorage.getItem('userInfo')).id
      } else {
        return
      }
      let url =
        window.location.href.split('?')[0] +
        '?type=share' +
        '&uid=' +
        uid +
        '&scenes=' +
        (this.liveInfo.live_status == 1 ? 'live' : 'live_advance')
      if (this.liveInfo.live_status == 1) {
        url +=
          '&live_id=' +
          this.liveInfo.live_id +
          '&scenesId=' +
          this.liveInfo.scenes_id
      } else {
        url += '&advance_id=' + this.liveInfo.advance_id
      }
      url += '&time=' + parseInt(Math.random(0, 1) * 100)
      wx.showMenuItems({
        menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline'], // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
      })
      let liveInfoData = this.liveInfo
      let times =
        liveInfoData.live_status == 1
          ? liveInfoData.start_times
          : liveInfoData.live_time

      let shareInfo = {
        title:
          liveInfoData.live_status == 1
            ? liveInfoData.title
            : liveInfoData.title + times + ' 不见不散',
        desc: liveInfoData.live_status == 1 ? '正在直播中' : liveInfoData.title,
        link: url, // 分享链接，该链接域名必须与当前企业的可信域名一致'
        // imgUrl: liveInfoData.cover_image,
        imgUrl: 'https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/yi_logo.jpg',
      }
      console.log(liveInfoData,'-----')
      // alert('00')
      wx.onMenuShareAppMessage(shareInfo)
      wx.onMenuShareTimeline(shareInfo)
    },
    //直播获取预告信息
    async getIndexLiveData() {
      this.params = {
        live_id: this.$router.history.current.query.live_id,
        advance_id: this.$router.history.current.query.advance_id,
      }
      this.http('ClientLive.getLiveInfo', this.params).then((e) => {
        this.liveInfo = {
          ...e.content,
          start_times: format(e.content.start_time * 1000, 1),
        }
        // let hrr = []
        // let obj = {}
        // //截取内部参数
        // let params = url.substr(url.indexOf('?') + 1)
        // //逗号隔开
        // let str = params.replace(/\&/g, ',')
        // let crr = []
        // str.split(',').map((i, index) => {
        //   crr.push(i.replace(/\=/g, ',').split())
        // })
        // crr.map((item) => {
        //   item.forEach((i) => {
        //     hrr.push(i.split(','))
        //   })
        // })
        // hrr.map((item) => {
        //   obj[item[0]] = item[1]
        // })
        this.$store.commit('shareFg', false)
        if (this.$store.state.shareStr != 'live') {
          new share(
            {
              startUrl: window.location.href,
            },
            this.$store,
            'live'
          )
        } else {
          this.shareModelFg()
        }
        if (
          e.content.live_status == 1 ||
          (e.content.live_id > 0 && e.content.advance_status == 0)
        ) {// 直播中
          // live_status == 0 &&advance_status == 0  直播已结束
          let userInfo = JSON.parse(localStorage.getItem('userInfo'))
          this.loginUser = {
            union_id: '1123123',
            nick_name: userInfo.nick_name,
            uid: userInfo.id + '',
            avatar: userInfo.avatar,
            app_key: config.liveAppKey,
            live_id: this.liveInfo.live_id + '',
            user_id: userInfo.id + '',
            open_id: userInfo.open_id,
            wechat_app_id: 'wxc0eee2bad939864a',
          }
          this.isLive = true

        } else {
          console.log(e.content.advance_live_id,'3393993')
          this.isNotice = true
          this.leftTime =
            (this.liveInfo.start_time - this.liveInfo.now_time) * 1000
          this.countTime()
          let advance_live_id = e.content.advance_live_id;
          this.gotoaddLiveBehavior(advance_live_id)
    
        }
      })
    },
    async gotoaddLiveBehavior(live_id_x){
          await this.http("ClientLive.addLiveBehavior", {
            live_id: live_id_x,
            scenes_id: 0,
            share_sign_no: localStorage.getItem("shareId"),
            type:2 // 预告进去  不传默认1
          });
    },
    // 倒计时
    countTime() {
      // 定义变量 d,h,m,s保存倒计时的时间
      if (this.leftTime >= 0) {
        // 天
        this.day = Math.floor(this.leftTime / 1000 / 60 / 60 / 24)
        let h = Math.floor((this.leftTime / 1000 / 60 / 60) % 24)
        this.hour = h < 10 ? '0' + h : h // 分
        let m = Math.floor((this.leftTime / 1000 / 60) % 60)
        this.min = m < 10 ? '0' + m : m // 秒
        let s = Math.floor((this.leftTime / 1000) % 60)
        this.second = s < 10 ? '0' + s : s
        this.leftTime = this.leftTime - 1000
        setTimeout(this.countTime, 1000)
      } else {
        // this.getIntoRoomStatus()
        this.day = 0
        this.hour = '00'
        this.min = '00'
        this.second = '00'
      }
    },
    onSelect(option) {
      if (option.icon == 'wechat' || option.icon == 'wechat-moments') {
        this.show = true
        this.showShare = false
      } else {
        this.isPoster = true
        this.showShare = false
      }
    },
    // 获取直播间权限
    async getIntoRoomStatus() {
      let _this = this
      let params = {
        live_id: this.$router.history.current.query.live_id,
        advance_id: this.$router.history.current.query.advance_id,
      }
      
      let res = await this.http('ClientLive.getIntoRoomStatus', params)
      this.getStringFg(window.location.href)
      if (res.content.status == 1 || res.content.is_test == 1 || res.content.live_end == 1) {
        _this.getIndexLiveData()
      } else {
        Dialog.alert({
          message: '暂无权限观看',
          theme: 'round-button',
        }).then(() => {
          _this.$router.push({
            path: './liveModel',
          })
        })
      }
    },

    liveModel(e) {
      if (e.type == 'back') {
        if (this.isShare) {
          this.jumpHome('./homeIndex')
        } else {
          this.$router.back()
        }
      } else if (e.type == 'goShop' || e.type == 'buy') {
        // live_id121 3
        // scenes_id

        this.http('ClientLive.getGoodsTypeInfo', {
          goods_id: e.data.goods_id,
        }).then((res) => {
          if (res.status == 200) {
            window.sessionStorage.setItem('live_id', this.loginUser.live_id)
            window.sessionStorage.setItem('scenes_id', e.data.scenes_id)
            this.isLive = false
            this.loginUser = {}
            if (res.content.type == 2) {
              localStorage.setItem('package_id', res.content.id)
              localStorage.setItem('num', 1)
              localStorage.setItem('type', 'package')
              this.$router.push({
                path: './ConfirmOrder',
              })
              this.$refs.live.logout(true)
            } else {
              this.$router.push({
                path: '/shopDetails',
                query: {
                  goods_id: res.content.id,
                  isLive: true,
                },
              })
              this.$refs.live.logout(true)
            }
          }
        })
      } else if (e.type == 'error') {
        if (this.isShare) {
          this.jumpHome('./homeIndex')
        } else {
          this.$router.back()
        }
      } else if (e.type == 'report') {
        window.localStorage.setItem('report_live_id', this.loginUser.live_id)
        this.$router.push({
          path: '/liveReport',
        })
      }
      console.log(e.type)
    },
    //回放列表详情
    seeVideo() {
      this.videos = this.liveInfo.cover_video
      this.isShow = true
    },
    // 关闭
    clearIsShowFg() {
      this.isShow = false
    },
    // 打开分享
    async openShareModel() {
      this.shareInit()
      this.showShare = true
    },
    //获取url字符串
    getStringFg(url) {
      let hrr = []
      let obj = {}
      //截取内部参数
      let params = url.substr(url.indexOf('?') + 1)
      //逗号隔开
      let str = params.replace(/\&/g, ',')
      let crr = []
      str.split(',').map((i, index) => {
        crr.push(i.replace(/\=/g, ',').split())
      })
      crr.map((item) => {
        item.forEach((i) => {
          hrr.push(i.split(','))
        })
      })
      hrr.map((item) => {
        obj[item[0]] = item[1]
      })
      localStorage.setItem('shareInfo', JSON.stringify(obj))
      if (obj.type == 'share') {
        this.shareExtensionFg(obj)
      } else if (JSON.parse(localStorage.getItem('shareInfo')).uid) {
        this.shareExtensionFg(JSON.parse(localStorage.getItem('shareInfo')))
      }
      return obj
    },
    //分享关系
    async shareExtensionFg(obj) {
      this.isBtn = true
      let params = {
        share_member_id: obj.uid,
        share_staff_id: 0,
        scenes: obj.scenes,
        extend_id: obj.scenes == 'live' ? obj.live_id : obj.advance_id,
      }
      if (obj.scenes == 'live') {
        params = {
          ...params,
          extend_id2: obj.scenesId,
        }
      }
      let res = await this.http('Client.shareExtension', params)
      localStorage.setItem('shareId', res.content.share_sign_no)
      sessionStorage.setItem('isAddLiveBehavior', 1)
    },

    shareInit() {
      let uid
      if (localStorage.getItem('userInfo')) {
        uid = JSON.parse(localStorage.getItem('userInfo')).id
      } else {
        return
      }
      let url =
        window.location.href.split('?')[0] +
        '?type=share' +
        '&uid=' +
        uid +
        '&scenes=' +
        (this.liveInfo.live_status == 1 ? 'live' : 'live_advance')
      if (this.params.live_id) {
        url +=
          '&live_id=' +
          this.params.live_id +
          '&scenesId=' +
          this.liveInfo.scenes_id
      } else {
        url += '&advance_id=' + this.params.advance_id
      }
      url += '&time=' + parseInt(Math.random(0, 1) * 100)
      
      this.painting = {
        width: '640px',
        height: '872px',
        borderRadius: '20px',
        background: '#ffffff',
        views: [
          {
            type: 'image',
            url: this.liveInfo.cover_image,
            css: {
              top: '0',
              left: '0',
              borderRadius: '20px',
              width: '640px',
              height: '372px',
            },
          },

          {
            type: 'image',
            url: require('../assets/img/sf-bj-img.png'),
            css: {
              top: '372px',
              left: '0',
              width: '640px',
              height: '108px',
            },
          },

          {
            type: 'text',
            text: this.liveInfo.title,
            css: {
              top: '390px',
              left: '40px',
              width: '560px',
              maxLines: 1,
              fontSize: '26px',
              fontWeight: '600',
              color: '#fff',
            },
          },

          {
            type: 'text',
            text:
              (this.liveInfo.live_status == 1
                ? this.liveInfo.start_times
                : this.liveInfo.live_time) + '准时开播',
            css: {
              top: '430px',
              left: '40px',
              width: '560px',
              maxLines: 1,
              fontSize: '26px',
              color: '#fff',
            },
          },

          {
            type: 'text',
            text: '直播介绍',
            css: {
              top: '505px',
              left: '40px',
              fontSize: '28px',
              color: '#111111',
            },
          },

          {
            type: 'text',
            text: this.liveInfo.describe,
            css: {
              top: '557px',
              left: '40px',
              fontSize: '28px',
              color: '#616161',
              maxLines: '6',
              lineHeight: '42px',
              width: '300px',
            },
          },
          {
            type: 'qrcode',
            content: url,
            css: {
              bottom: '125px',
              right: '56px',
              color: '#000',
              background: '#fff',

              width: '200px',
              height: '200px',
              borderWidth: '10px',
              borderColor: '#fff',
            },
          },

          {
            type: 'text',
            text: '长按识别二维码',
            css: {
              bottom: '98px',
              left: '384px',
              maxLines: 1,
              fontSize: '26px',
              color: '#7D7D7D;',
            },
          },
          {
            type: 'text',
            text: '观看直播',
            css: {
              bottom: '68px',
              left: '440px',
              maxLines: 1,
              fontSize: '24px',
              color: '#7D7D7D;',
            },
          },
        ],
      }
    },
    //成功生成海报
    success(src) {
     
      this.posterImg= src
      // console.log(src)
    },
    fail(err) {
      console.log(err)
    },
  },
  beforeDestroy() {
    sessionStorage.removeItem('isreload') 
    if (this.isLive) {
      this.$refs.live.logout(true)
      this.loginUser = {}
      this.isLive = false
    }
  },
}
</script>



<style lang="scss" scoped>
.content_container {
  position: relative;
  z-index: 100000;
}
.share-tip {
  z-index: 100000;
}
.n_save {
  font-size: 32px;
  color: #ffffff;
  text-align: center;
  margin-top: 40px;
}
.n_margtop {
  width: 80%;
  height: auto;
  display: block;
  margin: 200px auto;
}
.wrapper img {
  width: 80%;
  margin: 10vh auto 0;
}
.n_shareBtn {
  display: block;
  width: 236px !important;
  margin: 400px auto 0;
}
.notice {
  width: 100%;
  height: 100vh;
  background: #131313;
}
.notice-header {
  width: 100%;
  height: 423px;
  background: rgba(0, 0, 0, 0.5);
  position: relative;
  overflow: hidden;
}
.notice-img {
  width: 100%;
  height: auto;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
}
.notice-play {
  width: 50px;
  height: 56px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.notice-title {
  margin: 0 32px;
  font-size: 40px;
  font-weight: 600;
  color: #ffffff;
  line-height: 40px;
  text-align: center;
  padding: 50px 0 33px;
  border-bottom: 1px solid rgba(51, 51, 51, 1);
}
.notice-title-time {
  margin-top: 15px;
  font-size: 26px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 26px;
  font-weight: 500;
}

.count-down {
  text-align: center;
  .count-title {
    color: rgba(255, 255, 255, 0.7);
    margin-top: 30px;
    font-size: 34px;
    line-height: 34px;
  }
  .count-model {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    > div {
      width: 69px;
      height: 69px;
      text-align: center;
      background: #454545;
      border-radius: 20px;
      font-size: 32px;
      font-weight: 500;
      color: #ffffff;
      line-height: 69px;
    }
    p {
      font-size: 24px;
      font-weight: 400;
      color: #ffffff;
      line-height: 69px;
      margin: 0 17px;
    }
  }
}
.notice-introduce {
  margin-top: 50px;
  font-size: 34px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 34px;
  text-align: center;
}

.notice-p {
  padding: 0 40px;
  font-size: 28px;
  color: #ffffff;
  line-height: 40px;
  margin-top: 25px;
}

.notice-btn {
  width: 686px;
  height: 88px;
  background: #ee0a24;
  border-radius: 48px;
  text-align: center;
  line-height: 88px;
  position: fixed;
  bottom: 135px;
  left: 32px;
  color: #fff;
}
.goHome {
  position: fixed;
  bottom: 20px;
  width: 100%;
  text-align: center;
  margin-top: 50px;
  font-size: 28px;
  font-weight: 400;
  color: #ffffff;
  line-height: 40px;
}
</style>
